
const popup = () => {
    if (window.location.search.indexOf('complete=1') < 0) {
        return;
    }
    document.body.classList.add('popup-active');
}

export default popup;